<script>
    export let callback = () => {};
    export let number = null;
    export let disabled = false;

    import { formatNumber } from './NumberUtil'

    let formattedNumber = formatNumber(number)

    function checkInput(event) {
        const newValue = event.target.value.trim()

        // This allows users to clear the input field after filling it
        if (newValue === '') {
            number = null
            formattedNumber = ''
            callback()
            return
        }

        // Replace comma with dot and try to convert to a Number
        const newNumber = Number(newValue.replaceAll(',', '.'))

        // If we don't end up with a valid Number, reset the input to the previous value (reject the input)
        if (Number.isNaN(newNumber)) {
            event.target.value = formattedNumber
            return
        }

        // The new value is valid, update
        number = newNumber
        formattedNumber = newValue.replace('.', ',')
        callback()
    }
</script>

<input
    on:input={checkInput}
    value={formattedNumber}
    {disabled}
    type="text"
    inputMode="decimal"
/>

<style lang="scss">
    input {
        @include text-input;
        @include text-input-disabled-state;
    }
</style>
